import { useQuery } from '@tanstack/react-query'

import { PkgWarehouse } from '@/api/user-package/types/UserPkg'
import { useOfficePagePermissions } from '@/hooks/useOfficePagePermissions'
import { QUERY_KEYS } from '@/lib/queryKeys'

import { getPkgCaseCounts } from '../pkgCaseService'

export function usePkgCaseCounts(warehouse?: PkgWarehouse, enabled = true) {
  const { canViewPkgCases } = useOfficePagePermissions()
  return useQuery({
    queryKey: [QUERY_KEYS.PKG_CASE_COUNTS, warehouse ?? 'all'],
    queryFn: () => getPkgCaseCounts(warehouse),
    enabled: enabled && canViewPkgCases,
    refetchInterval: 60_000,
  })
}
